import { render, staticRenderFns } from "./ClientDocuments.vue?vue&type=template&id=c6ca3720&scoped=true&"
import script from "./ClientDocuments.vue?vue&type=script&lang=js&"
export * from "./ClientDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ClientDocuments.vue?vue&type=style&index=0&id=c6ca3720&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ca3720",
  null
  
)

export default component.exports